'use strict';


import { Cache, Loader, RepeatWrapping, Texture } from 'three';

let plugTexture = null;

export class LazyTextureLoader extends Loader{
    constructor (manager) {
        super(manager);

        this.isLazyTextureLoader = true;
    }

    load( url, onLoad, onProgress, onError ) {

        if ( url === undefined ) url = '';
        if ( this.path !== undefined ) url = this.path + url;
        url = this.manager.resolveURL( url );

        const cached = Cache.get( url );
        if ( cached !== undefined ) {

            scope.manager.itemStart( url );
            setTimeout(() => {

                if ( onLoad ) onLoad( cached );

                this.manager.itemEnd( url );

            }, 0 );

            return cached;
        }

        const texture = new Texture();

        if (plugTexture === null) {
            const canvas = document.createElement('canvas');
            canvas.width = 4;
            canvas.height = 4;
            const context = canvas.getContext('2d');
            context.fillStyle = '#cccccc';
            context.fillRect(0,0,4,4);
            plugTexture = new Texture(canvas);
            plugTexture.wrapS = RepeatWrapping;
            plugTexture.wrapT = RepeatWrapping;
            plugTexture.generateMipmaps = false;
        }

        texture.image = plugTexture.image;
        texture.needsUpdate = true;

        const fetchOptions = {};
        fetchOptions.credentials = ( this.crossOrigin === 'anonymous' ) ? 'same-origin' : 'include';
        fetchOptions.headers = this.requestHeader;

        fetch( url, fetchOptions )
            .then(res => res.blob())
            .then(blob => {
                const blobUrl = URL.createObjectURL(blob);
                const image = new Image();
                image.onload = () => {
                    texture.dispose();
                    texture.image = image;
                    texture.needsUpdate = true;
                    Cache.add( url, texture );
                    if ( onLoad ) onLoad( texture );
                    this.manager.itemEnd( url );
                };
                image.onerror = (e) => {
                    if ( onError ) onError( e );
                    this.manager.itemError( url );
                    this.manager.itemEnd( url );
                };
                image.src = blobUrl;
            })
            .catch(e => {

            if ( onError ) onError( e );

            this.manager.itemError( url );
            this.manager.itemEnd( url );

        } );

        this.manager.itemStart( url );

        return texture;
    }

}